  window._theme = window._theme || {}; 
  const transcriptModalBtn = document.querySelector('.transcript-modal-btn')
  const transcriptModalBox = document.querySelector('.transcript-modal')
  const transcriptCloseModalBox = document.querySelector('.close-transcript-modal')
  transcriptModalBtn?.addEventListener('click',()=>{
    transcriptModalBox.classList.add('active');
    if(_theme.isMobile) {
      $('*').not($('.transcript-modal').find('*')).not('.transcript-modal').not($('.transcript-modal').parents()).attr('aria-hidden','true');
      }
    _theme.focusTrap($('.transcript-modal'),function(){
        $('.close-transcript-modal').focus();
    })
    document.querySelector('body').classList.add('transcript-modal-open')
    _theme.toggleOverlay(1)
  })
  transcriptCloseModalBox?.addEventListener('click',()=>{
    transcriptModalBox.classList.remove('active')
    if(_theme.isMobile) {
      $('*').not($('.transcript-modal').find('*')).not('.transcript-modal').not($('.transcript-modal').parents()).removeAttr('aria-hidden','true');
      }
    _theme.toggleOverlay(0)
    document.querySelector('body').classList.remove('transcript-modal-open')
  })
